import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FnUtilService, FnToasterService, FnSelectModule } from 'foundation';
import { EOTeam, EOTeamGroup } from '../../../../modal/entity.modal';
import { PosHttpService } from '../../../../services/pos.http.service';

@Component({
  selector: 'app-team-group-model',
  templateUrl: './team-group-model.component.html',
  styleUrl: './team-group-model.component.scss'
})
export class TeamGroupModelComponent implements OnInit {
constructor(@Inject(MAT_DIALOG_DATA) public dialogData: HwDialogData, private dialogRef: MatDialogRef<TeamGroupModelComponent>, private fnutilservice: FnUtilService, private toaster: FnToasterService, private fnSelectModule: FnSelectModule, private posHttpSvcs : PosHttpService) {
    if (!this.fnutilservice.isEmptyObject(this.dialogData.eoTeamGroup)) {
      this.objectHash.primaryKey=this.dialogData.eoTeamGroup.primaryKey;
      this.objectHash.id = this.dialogData.eoTeamGroup.id;
      this.objectHash.isActive = this.dialogData.eoTeamGroup.isActive;
      this.objectHash.textDesc = this.dialogData.eoTeamGroup.textDesc;
      this.objectHash.teams = this.fnutilservice.arrayFromArrayOfMap(this.dialogData.eoTeamGroup.teams,'primaryKey');
    }
  }
  ngOnInit(): void {
   this.loadTeamArray();
  }

  teamsArray: EOTeam []=[];
  objectHash :EOTeamGroup= {
    primaryKey:0,
    id: '',
    isActive: true,
    textDesc: '',
    teams:[]
  }
 
  close() {
    this.dialogRef.close();
  }


  loadTeamArray(){
    this.posHttpSvcs.authGet('v1/ui/getEOTeamArray', 'getEOTeamArray').subscribe((resp =>{
      if(resp.isError){
        this.toaster.error("EOTeamArray is not loaded");
      }
      this.teamsArray = resp.data;
    }))
  }
  

  add() {
    if (this.fnutilservice.isEmptyObject(this.objectHash.id)) {
      this.toaster.error('ID can not be null');
      throw new Error();
    }
    if (this.fnutilservice.isEmptyObject(this.objectHash.textDesc)) {
      this.toaster.error('Text Description can not be null');
      throw new Error();
    }
    this.dialogRef.close(this.objectHash);
  }

}
interface HwDialogData {
  eoTeamGroup: any;
}
